import React from 'react';
import { useIntl } from 'react-intl';

import SummaryTable from './SummaryTable';
import { MenuItemsInsight } from '../../../../apis/merchant-gateway/insights';
import { useInsightSubRoutes } from '../../hooks/useInsightsSubRoutes';
import { RowType } from '../../types';
import Ellipse from '../Ellipse';

type MenuItemsProps = {
  isFetching: boolean;
  isError: boolean;
  onRetry: () => void;
  menuItemsData?: MenuItemsInsight;
};

const MenuItems = ({ isFetching, isError, onRetry, menuItemsData }: MenuItemsProps) => {
  const { formatMessage } = useIntl();
  const { menuLink } = useInsightSubRoutes();

  return (
    <SummaryTable
      isFetching={isFetching}
      isError={isError}
      onRetry={onRetry}
      title={formatMessage({ id: 'insights.menu.header' })}
      tooltip={formatMessage({ id: 'insights.menu.tooltip' })}
      link={menuLink}
      rows={
        menuItemsData?.data.menuItems.total.map((item, index) => ({
          type: RowType.Menu,
          icon: <Ellipse>{index + 1}</Ellipse>,
          title: item.itemName,
          itemsCount: item.units,
        })) ?? []
      }
    />
  );
};
export default MenuItems;
